import * as common from './_common.js';
import * as validation from './_validation.js';
import * as unread from './_userNotices.js';
import './_player.js';

// <script>内で使えるようグローバルに定義
Object.assign(window, common, validation, unread);

export * from './_common.js';
export * from './_validation.js';
export * from './_userNotices.js';
